import React from "react";
import FormAlert from "./FormAlert";

const Receipt = () => (
  <FormAlert
    title="Tak for din henvendelse"
    text="Vi kontakter dig inden for 48 timer med et uforpligtende tilbud.

          Vi glæder os til at tale med dig!"
  />
);

export default Receipt;
